export default __webpack_public_path__ + "static/media/Swastik Aggarwal _YOUTUBE STREAM TEAM.d2ec4f15.jpg";